import axios from 'axios'
axios.defaults.timeout = 10000
axios.defaults.headers.post['Content-Type'] = 'application/x-www=form-urlencoded'
var prefix = ''
if (process.env.NODE_ENV === 'production') {
  prefix = '/shop-front'
}
export default {
  fetchGet (url, params = {}) {
    return new Promise((resolve, reject) => {
      axios.get(prefix + url, params).then(res => {
        resolve(res.data)
      }).catch(error => {
        reject(error)
      })
    })
  },
  fetchPost (url, params = {}) {
    return new Promise((resolve, reject) => {
      axios.post(prefix + url, params).then(res => {
        resolve(res.data)
      }).catch(error => {
        reject(error)
      })
    })
  }
}



// WEBPACK FOOTER //
// ./src/api/public.js